import { render, staticRenderFns } from "./allButton.vue?vue&type=template&id=02ce2180&"
import script from "./allButton.vue?vue&type=script&lang=js&"
export * from "./allButton.vue?vue&type=script&lang=js&"
import style0 from "./allButton.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports